import { motion } from "framer-motion";
import { BadgeCheck, Shield, Zap, Globe } from "lucide-react";

const features = [
  {
    icon: BadgeCheck,
    title: "Verified Direct Links",
    description: "We cross-reference host names and property details to ensure the direct listing is a genuine match.",
  },
  {
    icon: Shield,
    title: "Secure & Private",
    description: "Your searches are securely stored in your private dashboard so you can access your direct booking links anytime, on any device. We never share your data with third parties or Airbnb.",
  },
  {
    icon: Zap,
    title: "Instant Access",
    description: "Get direct booking links in seconds. Simply enter your email to unlock verified results and save them to your private dashboard for later.",
  },
  {
    icon: Globe,
    title: "Works Worldwide",
    description: "Find direct links for properties across 190+ countries. If it's on Airbnb or Vrbo, we can find it.",
  },
];

const Features = () => {
  return (
    <section className="py-24">
      <div className="container mx-auto px-6">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <h2 className="font-display text-3xl md:text-5xl font-bold tracking-tight mb-4">
            Why travelers trust <span className="text-gradient-primary">bnbxo</span>
          </h2>
          <p className="text-muted-foreground text-lg max-w-xl mx-auto">
            Built for savvy travelers who want the best deal, every time.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-6 max-w-4xl mx-auto">
          {features.map((feature, i) => (
            <motion.div
              key={feature.title}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.1 }}
              className="group bg-card border rounded-2xl p-6 hover:shadow-card-hover transition-all hover:-translate-y-0.5"
            >
              <div className="w-10 h-10 rounded-lg bg-accent flex items-center justify-center mb-4 group-hover:bg-gradient-hero transition-colors">
                <feature.icon className="w-5 h-5 text-accent-foreground group-hover:text-primary-foreground transition-colors" />
              </div>
              <h3 className="font-display text-lg font-semibold mb-2">{feature.title}</h3>
              <p className="text-muted-foreground text-sm leading-relaxed">{feature.description}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Features;
